import React from "react"
import News from "../../../blocks/en/news_page"
import { Link, graphql } from "gatsby"

export const pageQuery = graphql`
query {
  news: newsYaml(slug: { eq: "krapukhin_signs_with_catenaccio" }) {
    ...NewsInfoEn
  }
}`

export default class NewsTextEn extends News {
  renderNews() {
    return (
      <div className="row">
        <div className="col-xl-12">
          <p>Stanislav Krapukhin, a striker of FC Riga, has officially become a client of Catenaccio Sports Agency.</p>
        </div>
      </div>
    )
  }
}